import { defineAsyncComponent } from 'vue'

export enum CpanelRouteName {
    Index = 'cpanel.index',
    ServerShow = 'cpanel.server.show',
    ServerAccountsIndex = 'cpanel.server.accounts.index',
    ServerAccountEmails = 'cpanel.server.account.emails',
    ServerAccountEmailResetPassword = 'cpanel.server.account.email.reset-password',
    ServerAccountEmailEditQuota = 'cpanel.server.account.email.edit-quota',
    ServerAccountAddonDomains = 'cpanel.server.accounts.addon-domains',
    ServerAccountsCreate = 'cpanel.server.accounts.create',
    ServerAccountsEdit = 'cpanel.server.accounts.edit',
    ServerAccountsResetPassword = 'cpanel.server.accounts.reset-password',
}

export default {
    routes: [
        {
            path: '/cpanel',
            name: CpanelRouteName.Index,
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'cPanel',
                icon: 'fal fa-envelope-open-text fa-fw',
                permission: 'manage-cpanel',
                auth: true,
                module: 'metatech/cpanel',
            },
            children: [
                {
                    path: 'servers/:serverId',
                    name: CpanelRouteName.ServerShow,
                    component: () => import('./views/server/Show.vue'),
                    meta: {
                        label: 'Server',
                        permission: 'manage-cpanel',
                    },
                    children: [
                        {
                            path: 'accounts',
                            name: CpanelRouteName.ServerAccountsIndex,
                            component: () => import('./views/server/accounts/Index.vue'),
                            meta: {
                                label: 'Accounts',
                                icon: 'circle-user',
                                permission: 'manage-cpanel',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: CpanelRouteName.ServerAccountsCreate,
                                    component: () => import('./views/server/accounts/Index.vue'),
                                    meta: {
                                        label: 'Create Account',
                                        permission: 'manage-cpanel',
                                    },
                                },
                                {
                                    path: ':accountId/edit',
                                    name: CpanelRouteName.ServerAccountsEdit,
                                    component: () => import('./views/server/accounts/Index.vue'),
                                    meta: {
                                        label: 'Edit Account',
                                        permission: 'manage-cpanel',
                                    },
                                },
                                {
                                    path: ':accountId/reset-password',
                                    name: CpanelRouteName.ServerAccountsResetPassword,
                                    component: () => import('./views/server/accounts/Index.vue'),
                                    meta: {
                                        label: 'Reset Password',
                                        permission: 'manage-cpanel',
                                    },
                                },
                                {
                                    path: ':accountId/addon-domains',
                                    name: CpanelRouteName.ServerAccountAddonDomains,
                                    component: () => import('./views/server/accounts/Index.vue'),
                                    meta: {
                                        label: 'Addon Domains',
                                        permission: 'manage-cpanel',
                                    },
                                },
                                {
                                    path: ':accountId/emails',
                                    name: CpanelRouteName.ServerAccountEmails,
                                    component: () => import('./views/server/accounts/Index.vue'),
                                    meta: {
                                        label: 'Account Emails',
                                        permission: 'manage-cpanel',
                                    },
                                    children: [
                                        {
                                            path: ':emailId/reset-password',
                                            name: CpanelRouteName.ServerAccountEmailResetPassword,
                                            component: () =>
                                                import('./views/server/accounts/Index.vue'),
                                            meta: {
                                                label: 'Reset Password',
                                                permission: 'manage-cpanel',
                                            },
                                        },
                                        {
                                            path: ':emailId/edit-quota',
                                            name: CpanelRouteName.ServerAccountEmailEditQuota,
                                            component: () =>
                                                import('./views/server/accounts/Index.vue'),
                                            meta: {
                                                label: 'Edit Quota',
                                                permission: 'manage-cpanel',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
}
